// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","453":"03346f77","455":"bbbaee9c","643":"089aee5c","821":"3cac35b8","885":"22f7f98d","977":"9d626833"}[chunkId] + ".chunk.js";
};